import React, { useState, useEffect, useRef } from "react";
import "./domain.css";

import Logistics from "../../assets/images/logistics-domain.png";
import { useLocation } from "react-router-dom";

import logDesc1 from "../../assets/images/domains/logDesc1.png";
import logDesc2 from "../../assets/images/domains/logDesc2.png";
import logDesc3 from "../../assets/images/domains/logDesc3.png";
import logDesc4 from "../../assets/images/domains/logDesc4.png";
import logDesc5 from "../../assets/images/domains/logDesc5.png";

import { Link } from "react-router-dom";

import AOS from "aos";
import "aos/dist/aos.css";

const LogisticsDomain = () => {
  const [play, setPlay] = useState(false);

  const vidRef = useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);
     AOS.init();
  }, []);

  const handlePlay = () => {
    if (vidRef && vidRef.current) {
      if (vidRef.current.paused) {
        setPlay(true);
        vidRef.current.play();
      } else {
        setPlay(false);
        vidRef.current.pause();
      }
    }
  };
  return (
    <>
      <div className="domain-banner logistics">
        <div className="bgoverlay"></div>
        <div className="container-fluid">
          <div className="content">
            <div className="heading" data-aos="fade-up" data-aos-duration="1500">
              <div className="heading-flex">
                <h2>Logistics</h2>
                <h4>
                  Upskill Your Transportation and Logistics Team with Dynamic
                  e-Training Solutions
                </h4>
                <p>
                  In the dynamic world of retail, where customer preferences
                  evolve rapidly and competition is fierce, empowering your team
                  with the right skills is essential for success. Our tailored
                  digital upskilling solutions meet the unique demands of
                  transportation and logistics, ensuring excellence and
                  compliance. From product knowledge to customer service, we
                  equip your team for success.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="domain-section">
        <div className="domain-banner-circle"></div>
        <div className="domain-section-content">
          <div className={play ? "domain-main-img play" : "domain-main-img"} >
            <img src={Logistics} alt="" />
          </div>
          <div className="domain-main">
            <div className="domain-main-content">
              <h2 data-aos="fade-up" data-aos-duration="1500">Challenges:</h2>
              <ul data-aos="fade-up" data-aos-duration="1500">
                <li>
                  Compliance and Safety: Logistics operations entail handling
                  hazardous materials and navigating complex regulations.
                  Training on safety protocols and regulatory compliance is
                  crucial to ensure a safe working environment.
                </li>
                <li>
                  Efficient Operations: Logistics companies strive to optimize
                  efficiency, reduce transit times, and minimize costs. Training
                  on lean principles and inventory management helps streamline
                  processes and improve overall efficiency
                </li>
                <li>
                  Technology Integration: The logistics industry adopts advanced
                  technologies like GPS tracking and route optimization
                  software. Training on these technologies enables employees to
                  leverage them effectively, enhancing operational performance.{" "}
                </li>
                <li>
                  Driver Training and Compliance: Ensuring driver safety and
                  regulatory compliance is vital for transportation companies.
                  Training programs cover defensive driving, hours-of-service
                  regulations, and vehicle inspection procedures to minimize
                  accidents and violations.{" "}
                </li>
                <li>
                  Data Security and Cybersecurity: With increased digitization,
                  protecting sensitive data and preventing cyber threats is
                  paramount. Training on cybersecurity best practices educates
                  employees on maintaining data security and recognizing
                  potential threats.
                </li>
              </ul>
            </div>
          </div>
          <div className="domain-main reverse">
            <div className="domain-main-content" data-aos="fade-up" data-aos-duration="1500">
              <h2>Why Choose Our e-Training Solutions?</h2>
            </div>

            <div className="logistic-desc2">
              <div className="logistic-desc2-inner">
                <div className="log-box">
                  <div className="log-img-desc">
                    <img
                      src={logDesc1}
                      alt="log-box"
                      data-aos="zoom-in" data-aos-duration="1500"
                    />
                  </div>
                  <span data-aos="zoom-in" data-aos-duration="1500">Anytime, Anywhere Learning</span>
                  <div className="red-border-log" data-aos="zoom-in" data-aos-duration="1500"></div>
                </div>
                <div className="log-box">
                  <div className="log-img-desc">
                    <img
                      src={logDesc2}
                      alt="log-box"
                      data-aos="zoom-in" data-aos-duration="1500"
                    />
                  </div>
                  <span data-aos="zoom-in" data-aos-duration="1500">Tailored to Industry Needs</span>
                  <div className="red-border-log" data-aos="zoom-in" data-aos-duration="1500"></div>
                </div>
                <div className="log-box">
                  <div className="log-img-desc">
                    <img
                      src={logDesc3}
                      alt="log-box"
                      data-aos="zoom-in" data-aos-duration="1500"
                    />
                  </div>
                  <span data-aos="zoom-in" data-aos-duration="1500">Cost-Effective Solutions</span>
                  <div className="red-border-log" data-aos="zoom-in" data-aos-duration="1500"></div>
                </div>
                <div className="log-box">
                  <div className="log-img-desc">
                    <img
                      src={logDesc4}
                      alt="log-box"
                      data-aos="zoom-in" data-aos-duration="1500"
                    />
                  </div>
                  <span data-aos="zoom-in" data-aos-duration="1500">Stay Current with Regulations</span>
                  <div className="red-border-log" data-aos="zoom-in" data-aos-duration="1500"></div>
                </div>
                <div className="log-box">
                  <div className="log-img-desc">
                    <img
                      src={logDesc5}
                      alt="log-box"
                      data-aos="zoom-in" data-aos-duration="1500"
                    />
                  </div>
                  <span data-aos="zoom-in" data-aos-duration="1500">Language Barrier? Not a Problem</span>
                  <div className="red-border-log" data-aos="zoom-in" data-aos-duration="1500"></div>
                </div>
              </div>
            </div>
          </div>
          <div className="domain-main">
            <div className="domain-main-content" data-aos="fade-up" data-aos-duration="1500">
              <h2>Ready to Elevate Your Team's Performance?</h2>
              <p>
                Empower your team with the knowledge and skills they need to
                thrive in the fast-paced world of transportation and logistics.
                Our eTraining solutions offer unmatched flexibility,
                customization, and cost-effectiveness, helping your business
                stay ahead of the curve while prioritizing safety and
                compliance.
              </p>

              <h4>
                Learn more about our eTraining solutions and how they can
                benefit your business.
              </h4>
              <Link className="read-more-product" to={"/request"}>
                <span>Contact Us !</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LogisticsDomain;
